module.exports = __webpack_public_path__ + "static/Uni_Text-dark-f650a028b7dd386fddf89370fe4b07cd.png";